import * as Turbo from "@hotwired/turbo"
import "@hotwired/turbo-rails"
import { registerControllers } from 'stimulus-vite-helpers'
import { Application } from '@hotwired/stimulus'
const controllers = import.meta.glob('../**/*_controller.js', { eager: true })

Turbo.session.drive = true
const application = Application.start()
Turbo.start()

console.log("controllers", controllers)
registerControllers(application, controllers)


Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};
